/* eslint-disable */
import createIcon from '../createIcon';

const IconExclamationCircleFilled = createIcon({
  name: 'icon-exclamation-circle-filled',
  content: '<path d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 627.2a38.4 38.4 0 100 76.8 38.4 38.4 0 000-76.8zM544 256h-64v349.12h64V256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});
export default IconExclamationCircleFilled;
